import { useEffect, useState } from 'react'
import { consumirApi } from '../../utils/consumoApi'
import { API_BASE_URL } from '../../utils/config.js' 
import { subYears, getYear, format } from 'date-fns'
import Table from '../../components/tables/TableFilter'
import Button from '../../components/common/Button'
import Notification from '../../components/common/Notification'
import Spinner from '../../components/common/Spinner'
import { FaFileExcel  } from "react-icons/fa"


const Contratos = () => {
  const [datos, setDatos] = useState([])
  const [selectedId, setSelectedId] = useState(null) // Manejar el ID seleccionado de un proyecto
  const [selectedDocumento, setSelectedDocumento] = useState(null) // Manejar el ID seleccionado de un proyecto
  const [anioContrato, setAnioContrato] = useState(getYear(new Date()))

  // Notificaciones y cargas
  const [cargando, setCargando] = useState(true)
  const [cargandoPdf, setCargandoPdf] = useState(false)
  const [error, setError] = useState("")
  const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
  const idEmpresa = JSON.parse(localStorage.getItem('empresa'))

  const columnas = [
    { titulo: 'id', campo: 'id' },
    { titulo: 'Contrato', campo: 'numero' },
    { titulo: 'Año', campo: 'anio' },
    { titulo: 'Documento', campo: 'documento_cliente' },
    { titulo: 'Nombres', campo: 'clientes' },
    { titulo: 'Nombre Proyecto', campo: 'proyecto' },
    { titulo: 'Fecha Contrato', campo: 'fecha_contrato' },
  ]

  useEffect(() => {
    obtenerContratos()
  }, [anioContrato]) 

  const obtenerContratos = async () => {
    const respuesta = await consumirApi('GET', `contrato/get/${idEmpresa}/${anioContrato}`) // Obtener contratos
    setDatos(respuesta.success ? respuesta.data : [])
    setCargando(false)
  }

  // Manejar selección de checkbox
  const seleccionContrato = (data) => {
    setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
    setSelectedDocumento(data.documento_cliente)
  }

  // generar y abrir PDF de la cotizacion 
  const manejadorPdf = async () => {
    setCargandoPdf(true)
    try {
      const respuesta = await consumirApi('GET', `contrato/generar-pdf/${idEmpresa}/${selectedDocumento}/${selectedId}`)
      if (respuesta.data.success) {
        window.open(respuesta.data.url, '_blank')
      } else {
        setError('Error al generar el PDF:', respuesta.data.message)
      }
    } catch (error) {
      setError('Error en el manejador PDF:', error)
    } finally {
      setCargandoPdf(false)
    }
  }

  const manejarCambioAnio = (e) => {
    setAnioContrato(e.target.value)
    setSelectedId(null)
  }

  return (
    <div className="w-full min-h-[calc(100vh-50px)]">
      <div className="max-w-full overflow-x-auto flex gap-3 items-center">
        <Button className="ml-5 mt-2" texto="CONTRATO" type="delete" disabled={!selectedId} onClick={manejadorPdf} />
        <span className="ml-2 mt-2">Año:</span>
        <select className="border rounded-md p-1 mt-2" value={anioContrato} onChange={manejarCambioAnio} >
          <option value={getYear(new Date())}>{getYear(new Date())}</option>
          <option value={getYear(subYears(new Date(), 1))}>{getYear(subYears(new Date(), 1))}</option>
          <option value={getYear(subYears(new Date(), 2))}>{getYear(subYears(new Date(), 2))}</option>
          <option value="all">TODOS</option>
        </select>
      <FaFileExcel size={30} color="green" className="ml-1 mt-2 inline cursor-pointer" onClick={() => window.open(`${API_BASE_URL}/export/contratos/${idEmpresa}`, "_blank")} />
        {cargandoPdf && <Spinner />}
      </div>

      {notificacion.estado && (
        <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
      )}
      {cargando ? (
        <Spinner />
      ) : datos.length === 0 ? (
        <div className="ml-5 mt-2">No se encontraron contratos</div>
      ) : (
        <Table
          datos={datos}
          listaCampos={columnas}
          mostrarChecks={true}
          seleccionFila={seleccionContrato} // Manejar el ID seleccionado
          selectedId={selectedId} // Manejar el ID seleccionado
        />
      )}
    </div>
  )
}

export default Contratos
